/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The AccountControllerDtoAccountDefaultInfoNicknameChangeLogHistoryData model module.
 * @module model/AccountControllerDtoAccountDefaultInfoNicknameChangeLogHistoryData
 * @version 1.0
 */
class AccountControllerDtoAccountDefaultInfoNicknameChangeLogHistoryData {
    /**
     * Constructs a new <code>AccountControllerDtoAccountDefaultInfoNicknameChangeLogHistoryData</code>.
     * @alias module:model/AccountControllerDtoAccountDefaultInfoNicknameChangeLogHistoryData
     */
    constructor() { 
        
        AccountControllerDtoAccountDefaultInfoNicknameChangeLogHistoryData.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>AccountControllerDtoAccountDefaultInfoNicknameChangeLogHistoryData</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/AccountControllerDtoAccountDefaultInfoNicknameChangeLogHistoryData} obj Optional instance to populate.
     * @return {module:model/AccountControllerDtoAccountDefaultInfoNicknameChangeLogHistoryData} The populated <code>AccountControllerDtoAccountDefaultInfoNicknameChangeLogHistoryData</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new AccountControllerDtoAccountDefaultInfoNicknameChangeLogHistoryData();

            if (data.hasOwnProperty('beforeNickname')) {
                obj['beforeNickname'] = ApiClient.convertToType(data['beforeNickname'], 'String');
            }
            if (data.hasOwnProperty('afterNickname')) {
                obj['afterNickname'] = ApiClient.convertToType(data['afterNickname'], 'String');
            }
            if (data.hasOwnProperty('createdAt')) {
                obj['createdAt'] = ApiClient.convertToType(data['createdAt'], 'Date');
            }
            if (data.hasOwnProperty('transactionNo')) {
                obj['transactionNo'] = ApiClient.convertToType(data['transactionNo'], 'Number');
            }
            if (data.hasOwnProperty('cost')) {
                obj['cost'] = ApiClient.convertToType(data['cost'], 'Number');
            }
            if (data.hasOwnProperty('managerNo')) {
                obj['managerNo'] = ApiClient.convertToType(data['managerNo'], 'Number');
            }
            if (data.hasOwnProperty('managerEmail')) {
                obj['managerEmail'] = ApiClient.convertToType(data['managerEmail'], 'String');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>AccountControllerDtoAccountDefaultInfoNicknameChangeLogHistoryData</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>AccountControllerDtoAccountDefaultInfoNicknameChangeLogHistoryData</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['beforeNickname'] && !(typeof data['beforeNickname'] === 'string' || data['beforeNickname'] instanceof String)) {
            throw new Error("Expected the field `beforeNickname` to be a primitive type in the JSON string but got " + data['beforeNickname']);
        }
        // ensure the json data is a string
        if (data['afterNickname'] && !(typeof data['afterNickname'] === 'string' || data['afterNickname'] instanceof String)) {
            throw new Error("Expected the field `afterNickname` to be a primitive type in the JSON string but got " + data['afterNickname']);
        }
        // ensure the json data is a string
        if (data['managerEmail'] && !(typeof data['managerEmail'] === 'string' || data['managerEmail'] instanceof String)) {
            throw new Error("Expected the field `managerEmail` to be a primitive type in the JSON string but got " + data['managerEmail']);
        }

        return true;
    }


}



/**
 * @member {String} beforeNickname
 */
AccountControllerDtoAccountDefaultInfoNicknameChangeLogHistoryData.prototype['beforeNickname'] = undefined;

/**
 * @member {String} afterNickname
 */
AccountControllerDtoAccountDefaultInfoNicknameChangeLogHistoryData.prototype['afterNickname'] = undefined;

/**
 * @member {Date} createdAt
 */
AccountControllerDtoAccountDefaultInfoNicknameChangeLogHistoryData.prototype['createdAt'] = undefined;

/**
 * @member {Number} transactionNo
 */
AccountControllerDtoAccountDefaultInfoNicknameChangeLogHistoryData.prototype['transactionNo'] = undefined;

/**
 * @member {Number} cost
 */
AccountControllerDtoAccountDefaultInfoNicknameChangeLogHistoryData.prototype['cost'] = undefined;

/**
 * @member {Number} managerNo
 */
AccountControllerDtoAccountDefaultInfoNicknameChangeLogHistoryData.prototype['managerNo'] = undefined;

/**
 * @member {String} managerEmail
 */
AccountControllerDtoAccountDefaultInfoNicknameChangeLogHistoryData.prototype['managerEmail'] = undefined;






export default AccountControllerDtoAccountDefaultInfoNicknameChangeLogHistoryData;

